import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';

interface Props {
    isOpened: boolean;
    setIsMenuOpened: (isOpen: boolean) => void;
}

const ToggledMenu = (props: Props) => {
    const onClick = () => {
        props.setIsMenuOpened(!props.isOpened);
    };

    return (
        <div className="lg:hidden pb-[8px] px-[12px] flex justify-end">
            <button
                type="button"
                onClick={() => onClick()}
                className="px-3 py-1 rounded text-xl leading-none transition-shadow duration-150 ease-in-out focus:shadow-[0_0_0_0.25rem] focus:outline-none focus:no-underline border border-[rgba(0,0,0,0.1)] text-[rgba(0,0,0,0.55)]"
            >
                <span
                    className="inline-block align-middle w-[30px] h-[30px] bg-center bg-no-repeat bg-contain"
                    style={{ backgroundImage: "url('/elements/icons/toggler.svg')" }}
                ></span>
            </button>
        </div>
    );
};

const ToggledMenuWithStore = () => {
    const { tabStore } = getStore();

    return <ToggledMenu isOpened={tabStore.isMenuOpened} setIsMenuOpened={tabStore.setIsMenuOpened} />;
};

export default observer(ToggledMenuWithStore);
